(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[141],{

/***/ 63:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9415);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 5630:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// original tool source from 'babel-plugin-superjson-next'
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withSuperJSONPage = exports.deserializeProps = exports.withSuperJSONInitProps = exports.withSuperJSONProps = void 0;
var hoistNonReactStatics = __webpack_require__(63);
var React = __webpack_require__(2983);
var superjson_1 = __webpack_require__(3500);
function withSuperJSONProps(gssp, exclude) {
    if (exclude === void 0) { exclude = []; }
    return function withSuperJSON() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result, excludedPropValues, _a, json, meta, props;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, gssp.apply(void 0, args)];
                    case 1:
                        result = _b.sent();
                        if (!('props' in result)) {
                            return [2 /*return*/, result];
                        }
                        if (!result.props) {
                            return [2 /*return*/, result];
                        }
                        excludedPropValues = exclude.map(function (propKey) {
                            var value = result.props[propKey];
                            delete result.props[propKey];
                            return value;
                        });
                        _a = superjson_1.default.serialize(result.props), json = _a.json, meta = _a.meta;
                        props = json;
                        if (meta) {
                            props._superjson = meta;
                        }
                        exclude.forEach(function (key, index) {
                            var excludedPropValue = excludedPropValues[index];
                            if (typeof excludedPropValue !== 'undefined') {
                                props[key] = excludedPropValue;
                            }
                        });
                        return [2 /*return*/, __assign(__assign({}, result), { props: props })];
                }
            });
        });
    };
}
exports.withSuperJSONProps = withSuperJSONProps;
function withSuperJSONInitProps(gip, exclude) {
    if (exclude === void 0) { exclude = []; }
    return function withSuperJSON() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result, excludedPropValues, _a, json, meta, props;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, gip.apply(void 0, args)];
                    case 1:
                        result = _b.sent();
                        excludedPropValues = exclude.map(function (propKey) {
                            var value = result[propKey];
                            delete result[propKey];
                            return value;
                        });
                        _a = superjson_1.default.serialize(result), json = _a.json, meta = _a.meta;
                        props = json;
                        if (meta) {
                            props._superjson = meta;
                        }
                        exclude.forEach(function (key, index) {
                            var excludedPropValue = excludedPropValues[index];
                            if (typeof excludedPropValue !== 'undefined') {
                                props[key] = excludedPropValue;
                            }
                        });
                        return [2 /*return*/, __assign(__assign({}, result), props)];
                }
            });
        });
    };
}
exports.withSuperJSONInitProps = withSuperJSONInitProps;
function deserializeProps(serializedProps) {
    var _superjson = serializedProps._superjson, props = __rest(serializedProps, ["_superjson"]);
    return superjson_1.default.deserialize({ json: props, meta: _superjson });
}
exports.deserializeProps = deserializeProps;
function withSuperJSONPage(Page) {
    function WithSuperJSON(serializedProps) {
        return React.createElement(Page, __assign({}, deserializeProps(serializedProps)));
    }
    hoistNonReactStatics(WithSuperJSON, Page);
    return WithSuperJSON;
}
exports.withSuperJSONPage = withSuperJSONPage;
//# sourceMappingURL=tools.js.map

/***/ }),

/***/ 4234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play",
      function () {
        return __webpack_require__(3358);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ play; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-superjson-plugin@0.4.9_n4425kxx5r4jmllhb73qnfryoi/node_modules/next-superjson-plugin/tools.js
var tools = __webpack_require__(5630);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(9293);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/page-title/page-title.tsx
var page_title = __webpack_require__(9224);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-widget/comment-widget.tsx
var comment_widget = __webpack_require__(5245);
// EXTERNAL MODULE: ../../packages/ui/src/components/alert/alert.tsx
var alert_alert = __webpack_require__(2649);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/play.tsx
/* provided dependency */ var process = __webpack_require__(3656);




function PlayGround() {
    const [showAlert, setShowAlert] = react.useState(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site_layout/* default */.Z, {
        title: "Playground",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(page_title/* PageTitle */.V, {
                        children: "Playground"
                    }),
                    showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
                        type: "info",
                        title: "Feel free to play around",
                        content: process.env.DOCKER ? "We don't remove comment automatically" : "We remove stale comments every 24 hours automatically.",
                        onClickDismiss: ()=>setShowAlert(false),
                        hideDismissButton: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_widget/* CommentWidget */._, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/play.tsx


var __N_SSG = true;
/* harmony default export */ var play = ((0,tools.withSuperJSONPage)(PlayGround));


/***/ }),

/***/ 5245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CommentWidget; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(710);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6991);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7853);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2983);
/* harmony import */ var _components_client_only__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8006);






function CommentWidget() {
    const { resolvedTheme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_client_only__WEBPACK_IMPORTED_MODULE_4__/* .ClientOnly */ .q, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "data-chirpy-comment": true,
                "data-chirpy-theme": resolvedTheme || "system",
                className: "my-16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/bootstrap/comment.js",
                strategy: "afterInteractive",
                "data-chirpy-domain": new URL((0,_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__/* .getAppURL */ .dj)()).hostname
            })
        ]
    });
}


/***/ }),

/***/ 9224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7648);
/* harmony import */ var _styles_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1569);





function PageTitle(param) {
    let { children , className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("w-fit space-y-4", className),
        ...restProps,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
                as: "h1",
                className: "w-fit !text-display-md font-bold !leading-none",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-1 w-11 rounded", _styles_common__WEBPACK_IMPORTED_MODULE_4__/* .gradient */ .FL)
            })
        ]
    });
}


/***/ }),

/***/ 2649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4979);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2953);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1356);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5177);





function Alert(props) {
    var _props_styles, _props_styles1, _props_styles2;
    const [style, Icon, iconButtonColor] = TYPE_STYLES[props.type];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("group relative flex w-full flex-row items-start justify-between rounded border p-4", style, (_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : _props_styles.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-1 flex-col items-start space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3", props.align === "center" ? "justify-center" : "justify-start", (_props_styles1 = props.styles) === null || _props_styles1 === void 0 ? void 0 : _props_styles1.container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                        size: 20,
                        className: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "text-base font-semibold leading-tight",
                                children: props.title
                            }),
                            props.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-1",
                                children: props.content
                            })
                        ]
                    })
                ]
            }),
            !props.hideDismissButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_3__/* .IconButton */ .h, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("invisible group-hover:visible", (_props_styles2 = props.styles) === null || _props_styles2 === void 0 ? void 0 : _props_styles2.dismissButton),
                onClick: props.onClickDismiss,
                "aria-label": "Dismiss",
                color: iconButtonColor,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: 18
                })
            })
        ]
    });
}
const TYPE_STYLES = {
    warn: [
        "bg-yellow-300 text-yellow-1100 border-yellow-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "yellow"
    ],
    info: [
        "bg-primary-300 text-primary-1100 border-primary-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "primary"
    ],
    success: [
        "bg-green-300 text-green-1100 border-green-600",
        _icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        "green"
    ]
};


/***/ }),

/***/ 4507:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(4507);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [393,98,570,293,774,888,179], function() { return __webpack_exec__(4234); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);